import React from 'react';
import ReactDOM from 'react-dom/client';
import '@styles/AppColors.css';
import 'Styles/AppFonts.css';
import './index.css';
import '@styles/Reset.css';
import '@styles/AntiHostOverrides.css';
import App from './App';

const root = ReactDOM.createRoot(
    document.getElementById('root-cashbuild') as HTMLElement
);

root.render(<App />);
